import { render, staticRenderFns } from "./EditarSubmenu.vue?vue&type=template&id=718eca0a"
import script from "./EditarSubmenu.vue?vue&type=script&lang=js"
export * from "./EditarSubmenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports